/* global axios */
import ApiClient from './ApiClient';

class LossReasonsApiClient extends ApiClient {
  constructor() {
    super('loss_reasons', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { loss_reason: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { loss_reason: data });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new LossReasonsApiClient();
